import http, {useHttp} from "./HttpService";

const apiEndPoint = "/anlage";

/**
 * Sollte mit useHttp abgerufen werden
 * @type {string}
 */
export const getMIPEndpoint = "/mip-foerderung/";

export const getAlternativeAbwasseranlagen = apiEndPoint + "/abwasserbehandlung/alleVonAktivenBetrieben/";

export const getAlternativeKommunaleAbwasseranlagen = apiEndPoint + "/abwasserbehandlung/alleVonAktivenBetriebenKommunal/";

export const getAlternativeKommunaleAbwasseranlagenLocal = apiEndPoint + "/abwasserbehandlung/alleVonAktivenBetriebenKommunalAbwasserbehandlungsanlagen/";

export function getJahresberichtAnlagenForBetrieb(betriebID) {
    return apiEndPoint + "/abwasserbehandlung/getJahresberichtAnlagenForBetrieb/" + betriebID + "/";
}

export function getJahresberichtJahreForAnlage(anlageID) {
    return apiEndPoint + "/abwasserbehandlung/getJahresberichtJahreForAnlage/" + anlageID + "/";
}

export function getEbtImportForAnlage(anlagenId) {
    return apiEndPoint + "/abwasserbehandlung/getEbtImportForAnlage/" + anlagenId;
}

/**
 * Hook zum Abrufen von Anlagenstatus. Kann parametrisiert werden, um nur Status für bestimmte Anlagen/Betrieb-Kombinationen abzurufen.
 * @param anlagenArt (optional) Spezifiziert Anlagenart
 * @param anlagenTyp (optional) Spezifiziert Anlagentyp
 * @param betriebTyp (optional) Spezifiziert Betriebtyp
 * @returns {[ResponseValues<any>, ((config?: AxiosRequestConfig, options?: RefetchOptions) => AxiosPromise<any>)]}
 */
export function useAnlagenstatus(anlagenArt, anlagenTyp, betriebTyp) {
    const queryParamString = "?anlagenArtId=" + anlagenArt + "&anlagenTypId=" + anlagenTyp + "&betriebTypId=" + betriebTyp;
    return useHttp("/anlagenstatus" + queryParamString);
}

export function postTeilentsorgungsraumExport(id) {
    return apiEndPoint + "/abwasserbehandlung/" + id + "/export/";
}

export function getEntsorgungsraumImportEndpoing(id) {
    return apiEndPoint + "/abwasserbehandlung/" + id + "/import/";
}

export function getEntlastungUebersichtEndpoint(parentAnlageId) {
    return apiEndPoint + "/entlastung/uebersicht/" + parentAnlageId;
}

export function getDrosselablaufAnlagenForBetrieb(betriebsId, anlagenart) {
    return apiEndPoint + "/entlastung/drosselablauf-betrieb/" + betriebsId + "/" + anlagenart;
}

export function getDrosselablaufAnlagen(anlagenart) {
    return apiEndPoint + "/entlastung/drosselablauf/" + anlagenart;
}

export function getKanalnetzUebersichtEndpoint(parentAnlageId) {
    return apiEndPoint + "/kanalnetz/uebersicht/" + parentAnlageId;
}

export function getKanalnetzSelbstueberwachungspflichtForAnlage(parentAnlageId) {
    return apiEndPoint + "/kanalnetz/selbstueberwachungspflichtForAnlage/" + parentAnlageId;
}

export function getAnlagenDateienEndpoint(id) {
    return apiEndPoint + "/" + id + "/dateien/";
}

export function getAnlagenDateiUploadEndpoint(id) {
    return apiEndPoint + "/" + id + "/upload-file/";
}

/**
 * Sollte mit useHttp abgerufen werden
 * @type {function(string): string}
 */
export const getAnlageEndpoint = (id) => `${apiEndPoint}/${id}`;

export function getAnlageHistorie(id) {
    return apiEndPoint + "/" + id + "/historie/";
}

export function getAnlagenByBetriebEndpoint(id) {
    return apiEndPoint + "?betrieb=" + id;
}

export function getStammdatenAntragAnlageEndpoint(id) {
    return apiEndPoint + "/" + id + "/aenderungsantrag/";
}

export function getAnlageHasIndirekteinleiterEndpoint(id) {
    return apiEndPoint + "/" + id + "/hasIndirektEinleiter/";
}

export function getMoeglicheAufnehmendeAnlagen(betriebsId, anlagentyp) {
    return apiEndPoint + "/moeglicheAufnehmendeAnlagen?anlagetyp=" + anlagentyp + "&betriebsId=" + betriebsId;
}

export function getIndirekteinleiter(anlageId) {
    return apiEndPoint + "/" + anlageId + "/indirekteinleiter/";
}

/**
 * Sollte mit useHttp abgerufen werden
 * @type {string}
 */
export const getAlleAnlageEndpoint = `${apiEndPoint}/`;

export function getAnlagenSucheEndpoint(params) {
    return `${apiEndPoint}/search${params ? "?" + params : ""}`;
}

export function postAnlagenExportEndpointConfiguration(selectedIds) {
    return {
        url: apiEndPoint + "/export/",
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function postAnlagenExportAllEndpointConfiguration(params) {
    return {
        url: apiEndPoint + "/export" + (params ? "?" + params : ""),
        method: "POST",
        responseType: "blob",
    };
}


export function getAnlagePfad(id) {
    return http.get(apiEndPoint + "/" + id + "/anlagePfad/");
}

export function postAbwasserbehandlung(anlage) {
    return http.post(apiEndPoint + "/abwasserbehandlung/", anlage);
}

export function postEntlastung(anlage) {
    return http.post(apiEndPoint + "/entlastung/", anlage);
}

export function postKanalnetz(anlage) {
    return http.post(apiEndPoint + "/kanalnetz/", anlage);
}

export function postKuehlwasser(anlage) {
    return http.post(apiEndPoint + "/kuehlwasser/", anlage);
}

export function postAbwasserbehandlungAenderungsantrag(antrag, id) {
    return http.post(apiEndPoint + "/abwasserbehandlung/" + id + "/aenderungsantrag/", antrag);
}

export function postEntlastungAenderungsantrag(antrag, id) {
    return http.post(apiEndPoint + "/entlastung/" + id + "/aenderungsantrag/", antrag);
}

export function postKuehlwasserAenderungsantrag(antrag, id) {
    return http.post(apiEndPoint + "/kuehlwasser/" + id + "/aenderungsantrag/", antrag);
}

export function putAbwasserbehandlung(anlage) {
    return http.put(`${apiEndPoint}/abwasserbehandlung/${anlage.id}`, anlage);
}

export function putEntlastung(anlage) {
    return http.put(`${apiEndPoint}/entlastung/${anlage.id}`, anlage);
}

export function putKanalnetz(anlage) {
    return http.put(`${apiEndPoint}/kanalnetz/${anlage.id}`, anlage);
}

export function putKuehlwasser(anlage) {
    return http.put(`${apiEndPoint}/kuehlwasser/${anlage.id}`, anlage);
}

export function patchAbwasserbehandlung(anlage) {
    return http.patch(`${apiEndPoint}/abwasserbehandlung/${anlage.id}`, anlage);
}

export function patchEntlastung(anlage) {
    return http.patch(`${apiEndPoint}/entlastung/${anlage.id}`, anlage);
}

export function patchKuehlwasser(anlage) {
    return http.patch(`${apiEndPoint}/kuehlwasser/${anlage.id}`, anlage);
}

export function deleteAnlageAenderungsantrag(id) {
    return http.delete(`${apiEndPoint}/${id}/aenderungsantrag/`);
}

export function postWiedervorlageForAnlageEndpoint(anlageId) {
    return apiEndPoint + "/" + anlageId + "/wiedervorlage/";
}

export function getWiedervorlageForAnlageEndpoint(anlageId) {
    return apiEndPoint + "/" + anlageId + "/wiedervorlage/";
}

export function getMessstelleAnlagenEndpoint(messstellenId) {
    return apiEndPoint + "/messstellenAnlagen/" + messstellenId;
}

export function getJahresberichtEndpoint(betriebId) {
    return "/jahresbericht/" + betriebId;
}

export function getJahresberichtByIDEndpoint(berichtID) {
    return "/jahresbericht/id/" + berichtID;
}

export function getJahresberichtDateienEndpoint(berichtID) {
    return "/jahresbericht/" + berichtID + "/dateien/";
}

export function getJahresberichtDateiUploadEndpoint(berichtID) {
    return "/jahresbericht/" + berichtID + "/upload-file/";
}

export function getJahresberichtExterneDateienEndpoint(berichtID) {
    return "/jahresbericht/" + berichtID + "/externe-dateien/";
}

export function getJahresberichtExterneDateiUploadEndpoint(berichtID) {
    return "/jahresbericht/" + berichtID + "/externe-upload-file/";
}

export function deleteJahresberichtQualitaetDateiEndpoint(berichtID) {
    return "/jahresbericht/deleteDateiQualitaet/" + berichtID;
}

export function deleteJahresberichtExterneDateiEndpoint(berichtID) {
    return "/jahresbericht/deleteDateiExterne/" + berichtID;
}

export function postJahresbericht(bericht) {
    return http.post("/jahresbericht/", bericht);
}

export function uploadEbtFile(jahresberichtId, file) {
    const formData = new FormData();
    formData.append("file", file);

    return http.post("/ebtImport/"+jahresberichtId+"/ebt-import", formData);
}

export function postJahresberichtWithUebernahme(bericht, uebernahmeBerichtId) {
    return http.post("/jahresbericht/uebernahme/" + uebernahmeBerichtId, bericht);
}

export function putJahresbericht(bericht) {
    return http.put("/jahresbericht/", bericht);
}

export function jahresberichtEinreichen(bericht) {
    return http.put("/jahresbericht/einreichen", bericht);
}

export function updateJahresberichtFreigabe(id, freigabe) {
    return http.put("/jahresbericht/" + id + "/freigabe/", freigabe);
}

export function deleteJahresbericht(berichtID) {
    return http.delete("/jahresbericht/" + berichtID);
}

export function getPrintJahresberichtEndpoint(berichtID) {
    return "/jahresbericht/" + berichtID + "/print/";
}

export function getJahresberichtSucheEndpoint(params) {
    return `/jahresbericht/search${params ? "?" + params : ""}`;
}

export function getSuevoaEnabledEndpoint() {
    return "/jahresbericht/suevoaEnabled/";
}

export function getAbfragenEndpoint() {
    return "/abfragen/";
}

export function getAbfrageExportEndpointConfiguration(abfrageId) {
    return {
        url: "/abfragen/abfrage/" + abfrageId,
        method: "GET",
        responseType: "blob",
    };
}

export function putParameter(jahresberichtId, messstelleId, parameterId, parameter) {
    return http.put("/jahresbericht/" + jahresberichtId + "/messstelle/" + messstelleId + "/parameter-messwert/" + parameterId, parameter);
}
